import axios from '../helpers/axios';
import * as errors from '../errors';
import { accessRulesAction, fetchPresetsAction } from '../modules/actions';
import { changeModalState } from '../modules/actions/modals';
import type { AppThunk, Notify } from '../typings/redux';
import { getTranslationKey } from '../modules/utils';

export const setUserBrandValue =
  (data: any): AppThunk =>
  (dispatch) =>
    dispatch({ type: 'SET_USER_BRAND_VALUE', payload: data });

export const getUserBrands = (): AppThunk<Promise<void>> => async (dispatch) => {
  try {
    const res = await axios.get('/api/userBrands?ownerRequest=true');
    dispatch({ type: 'SET_USER_BRANDS', payload: res.data });
  } catch (e) {
    console.log(e);
    errors.handleErrorWithRedirectIfNotAuth(e);
  }
};

export const createUserBrand =
  (data: any, notify: Notify): AppThunk<Promise<string | undefined>> =>
  async (dispatch) => {
    try {
      const res = await axios.post('/api/userBrand', data);
      notify({
        title: getTranslationKey('success'),
        message: getTranslationKey('successfullyCreated'),
        status: 'success',
        position: 'top-center',
        dismissible: true,
        dismissAfter: 3000
      });
      dispatch({ type: 'SET_USER_BRAND', payload: res.data });
      dispatch(accessRulesAction());

      return res.data._id as string;
    } catch (e) {
      dispatch(
        changeModalState({
          key: 'upgradeModal',
          state: true,
          desiredAction: 'brands',
          modalData: { addon: 'brands' }
        })
      );

      return undefined;
    }
  };

export const updateUserBrand =
  (data: any, notify?: Notify): AppThunk<Promise<void>> =>
  async (dispatch) => {
    try {
      const res = await axios.put('/api/userBrand', data);
      notify &&
        notify({
          title: getTranslationKey('success'),
          message: getTranslationKey('successfullyEdited'),
          status: 'success',
          position: 'top-center',
          dismissible: true,
          dismissAfter: 3000
        });
      dispatch({ type: 'SET_USER_BRAND', payload: res.data });
    } catch (e) {
      notify &&
        notify({
          title: getTranslationKey('error'),
          message: getTranslationKey('generalError'),
          status: 'error',
          position: 'top-center',
          dismissible: true,
          dismissAfter: 3000
        });
      errors.handleErrorWithRedirectIfNotAuth(e);
    }
  };

export const deleteUserBrand =
  (userBrand_id: string, notify: Notify): AppThunk<Promise<boolean>> =>
  async (dispatch) => {
    try {
      if (window.confirm(getTranslationKey('userBrand.rlyDelete'))) {
        await axios.delete('/api/userBrand', { params: { userBrand_id } });
        notify({
          title: getTranslationKey('success'),
          message: getTranslationKey('successfullyDeleted'),
          status: 'success',
          position: 'top-center',
          dismissible: true,
          dismissAfter: 3000
        });
        dispatch({ type: 'REMOVE_USER_BRAND', payload: userBrand_id });
        dispatch(accessRulesAction());
        dispatch(fetchPresetsAction());

        return true;
      }

      return false;
    } catch (e) {
      notify({
        title: getTranslationKey('error'),
        message: getTranslationKey('generalError'),
        status: 'error',
        position: 'top-center',
        dismissible: true,
        dismissAfter: 3000
      });
      errors.handleErrorWithRedirectIfNotAuth(e);

      return false;
    }
  };
